import { ChangeEvent, useRef, useState } from 'react';
import { Box, CircularProgress } from '@mui/material';
import { TextSpan } from '../../../Atoms/Text';
import { useSnackbar } from '../../../../Context/SnackbarContext';
import { CARD_OUTLINE_BUTTON } from './supplierCardStyles';
import { invoiceFileRefusal } from './pdfInvoice';

export interface InvoiceUploadProps {
  inputId: string;
  label: string;
  onUpload: (file: File) => Promise<unknown>;
}

/** Picks a PDF invoice of up to 10 MB and uploads it, refusing any other file. */
export const InvoiceUpload = ({ inputId, label, onUpload }: InvoiceUploadProps) => {
  const { setSnack } = useSnackbar();
  const fileInput = useRef<HTMLInputElement>(null);
  const [uploading, setUploading] = useState(false);

  const upload = async (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    event.target.value = '';
    if (!file) return;
    const refusal = invoiceFileRefusal(file);
    if (refusal) {
      setSnack({ message: refusal, open: true, type: 'error' });
      return;
    }
    setUploading(true);
    await onUpload(file);
    setUploading(false);
  };

  return (
    <Box className="flex items-center gap-3">
      <input
        type="file"
        accept=".pdf"
        hidden
        ref={fileInput}
        data-testid={inputId}
        onChange={upload}
      />
      <button
        type="button"
        className={CARD_OUTLINE_BUTTON}
        disabled={uploading}
        onClick={() => fileInput.current?.click()}>
        {uploading && <CircularProgress size={12} />}
        {label}
      </button>
      <TextSpan
        size="xs"
        color="grey6">
        Accepted: PDF
      </TextSpan>
    </Box>
  );
};
